import { render } from "./ProductSummary.vue?vue&type=template&id=38ca2bea"
import script from "./ProductSummary.vue?vue&type=script&lang=js"
export * from "./ProductSummary.vue?vue&type=script&lang=js"

import "./ProductSummary.vue?vue&type=style&index=0&id=38ca2bea&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__